import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingComponent } from '@app-shared/components/loading/loading.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'master';
  constructor(private translateService: TranslateService) {
    const lang = localStorage.getItem('lang') || 'ja';
    this.translateService.setFallbackLang(lang);
    this.translateService.use(lang);
  }
}
